import Flex from "app/components/UI/Flex";
import PropTypes from "prop-types";
import React from "react";
import classes from "./CheckoutLayout.module.css";

export const CheckoutLayout = ({ header, leftCol, rightCol }) => (
  <div className={classes.pageContainer}>
    {header}

    <Flex direction="row" wrap>
      <Flex size={1} className={classes.checkoutLayout__left}>
        {leftCol}
      </Flex>
      <div className={classes.checkoutLayout__right}>{rightCol}</div>
    </Flex>
  </div>
);

CheckoutLayout.propTypes = {
  header: PropTypes.node,
  leftCol: PropTypes.node,
  rightCol: PropTypes.node
};

export default CheckoutLayout;



// WEBPACK FOOTER //
// ./src/app/components/CheckoutLayout/CheckoutLayout.js